<template>
  <div style="overflow:hidden; text-overflow:ellipsis; white-space:nowrap; width:25vw;">
      <div style="text-align:center;font-size:20px;margin:-5px 0 5px 0;">推荐(看是否有人提到过类似的问题)</div>

      <div v-if="!ticketList || ticketList.length < 1"
        style="color:#EEE;font-size:20px;">输入标题后, 系统会匹配已有的可能相关的工单</div>

      <div class="ticket-title-line" v-for="e in ticketList" :key="e.orderId">
        <TicketTitle class="ticket-title-line-1"
          :ticketTitle="e.orderTitle"
          :ticketNo="e.orderId"
          target="_blank"/>
      </div>
  </div>
</template>

<script>
export default {
    name: 'NewTicketRelated',

    props: ['orderTitle'],

    data() {
      return {
        ticketList: []
      };
    },

    watch: {
      orderTitle() {
        this.on_orderTitle_change();
      }
    },

    methods: {
      on_orderTitle_change() {
        clearTimeout(window.NewTicketRelatedTimeoutId);
        window.NewTicketRelatedTimeoutId = setTimeout(this._doLoad, 1000); // 太快了？
      },

      _doLoad() {
        var _this = this;
        sdk.TicketApi().listRelatedTicketByTitle({
          ticketTitle: _this.orderTitle
        }).then(res => {
          if ( !res || !res.list ) {
            console.log('#47 listRelatedTicketByTitle', res);
            return;
          }

          _this.ticketList = res.list || [];
        });
      }
    },

    mounted() {
      this.on_orderTitle_change();
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/ticket/NewTicketRelated.vue